<template>
  <vue-form :state="formstate" @submit.prevent="submit()" >
    <b-row>
      <b-col cols="12">
        <validate tag="div">
          <label>{{ $t('views.exsbrefund.list.idClient') }}:</label>
          <base-select-input
            required
            v-model="item.idClient"
            :search-callback="userDataSearchCallback"
            :query-param="'userdata'"
            :display-values="['fullName', 'firmname1']"
            :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
          ></base-select-input>
        </validate>
      </b-col>
      <b-col cols="12">
        <validate tag="div">
          <label>{{ $t('views.exsbrefund.list.idBankPayment') }}:</label>
          <model-select :options="emptyOrNotFullBankPaymentsOptions" v-model="item.idBankPayment"></model-select>
        </validate>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12" md="6"  lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="value">{{ $t('views.exsbrefund.list.value') }}:</label>
            <input :placeholder="$t('views.exsbrefund.list.value')" v-model="item.value" type="number" class="form-control" id="value">
          </validate>
        </b-form-group>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <label>{{$t("views.exsbrefund.form.paymentDate")}}:</label>
        <VueCtkDateTimePicker :label="$t('views.exsbrefund.form.paymentDate')"
                              v-model="item.paymentDate"
                              no-header
                              format="YYYY-MM-DD"
                              :noButtonNow="true"
                              :onlyDate="true"
                              :right="true"
                              formatted="ll"
                              :no-label="true"
        >
        </VueCtkDateTimePicker>
      </b-col>
      <b-col sm="12" md="6" lg="4">
        <b-form-group>
          <validate tag="div">
            <label for="description">{{ $t('views.exsbrefund.form.description') }}:</label>
            <input :placeholder="$t('views.exsbrefund.form.description')" v-model="item.description" type="text" class="form-control" id="description">
          </validate>
        </b-form-group>
      </b-col>
    </b-row>
    <button type="button" class="btn btn-success" @click="submit()">{{ $t('buttons.submit') }}</button>
  </vue-form>
</template>

<script>
import VueForm from 'vue-form'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput.vue'
import { ModelSelect } from 'vue-search-select'
import moment from 'moment'

export default {
  name: 'Form',
  mixins: [VueForm],
  props: ['values', 'initialValues', 'handleSubmit'],
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker,
    ModelSelect
  },
  data () {
    return {
      formstate: {},
      emptyOrNotFullBankPaymentsOptions: []
    }
  },
  created () {
    this.fetchEmptyOrNotFullBankPayments()
  },
  computed: {
    item () {
      return this.initialValues || this.values
    }
  },
  methods: {
    submit () {
      if (this.formstate.$invalid) {
        return
      }
      this.handleSubmit()
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false, isCompany: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    getTitleForItem (item) {
      return moment(item.paymentDate.date).format('YYYY-MM-DD') + ' - ' + item.payer + ' - ' + item.description + ' - ' + this.$t('tableHeadings.valueLeft') + ': ' + item.valueLeft
    },
    async fetchEmptyOrNotFullBankPayments () {
      let response = await new ApiService('reports/emptyornotfullbankpayments').getResults()
      this.emptyOrNotFullBankPaymentsOptions = response.map(item => {
        return { text: this.getTitleForItem(item), value: '/core/public/index.php/api/e_x_s_b_bank_payments/' + item.id }
      })
      this.emptyOrNotFullBankPaymentsOptions.unshift({ text: this.$t('null'), value: null })
    }
  }
}
</script>

<style scoped>

</style>
